import { Form, Input, Select } from "antd";
import Radio from "antd/es/radio/index.js";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CategoryStartMethodSelect } from "~/components/form/CategoryStartMethodSelect.jsx";
import { HelpBubble } from "~/components/help/helpBubble.jsx";
import { $t } from "~/i18n.js";
import { updateIfNeeded } from "~/lib/helpers.js";
import { getBaseData } from "~/redux/flights/flights.actions.js";

export const PrivateKistForm = ({
  form,
  initialValues = {},
  onFinish = null,
  disabled = false,
  layout = "vertical",
  setDefaultPilot = false,
}) => {
  const dispatch = useDispatch();
  const { vliegers, lastUpdatedBaseData } = useSelector(
    (state) => state.flights
  );
  // for modal list select users, requires vliegers from base data
  useEffect(() => {
    setDefaultPilot &&
      updateIfNeeded(lastUpdatedBaseData, () => dispatch(getBaseData()));
  }, [setDefaultPilot, lastUpdatedBaseData, dispatch]);

  useEffect(() => {
    if (initialValues && form) {
      form.setFieldsValue({
        registratie:
          initialValues["registratie"] || initialValues["registration"] || "",
        callsign: initialValues["callsign"] || "",
        type: initialValues["type"] || "",
        flarm: initialValues["flarm"] || "",
        default_pilot_id: initialValues["default_pilot_id"] || null,
        kist_category: initialValues["category"],
        pilots: initialValues["pilots"] || 1,
        start_methode: initialValues["start_methode"],
      });
    }
  }, [initialValues, form]);

  return (
    <Form
      form={form}
      layout={layout}
      labelCol={layout === "horizontal" ? { span: 8 } : undefined}
      wrapperCol={layout === "horizontal" ? { span: 16 } : undefined}
      name="kist"
      preserve={false}
      requiredMark={false}
      {...(onFinish && { onFinish })}
      disabled={disabled}
      initialValues={{
        registratie:
          initialValues["registratie"] || initialValues["registration"] || "",
        callsign: initialValues["callsign"] || "",
        type: initialValues["type"] || "",
        flarm: initialValues["flarm"] || "",
        default_pilot_id: initialValues["default_pilot_id"] || null,
        kist_category: initialValues["category"],
        pilots: initialValues["pilots"] || 1,
        start_methode: initialValues["start_methode"],
      }}
    >
      <Form.Item
        label={$t("Registratie")}
        name="registratie"
        rules={[
          {
            required: true,
            message: $t("Voeg correcte registratie toe"),
            max: 10,
          },
        ]}
      >
        <Input placeholder="Registratie" />
      </Form.Item>

      <Form.Item
        label={$t("Callsign")}
        name="callsign"
        rules={[
          {
            required: false,
            message: $t("Maximaal ${max} characters", { max: 10 }),
            max: 10,
          },
        ]}
      >
        <Input placeholder="Callsign" />
      </Form.Item>

      <Form.Item
        label={$t("Type")}
        name="type"
        rules={[
          {
            required: false,
            message: $t("Maximaal ${c} characters", { c: 50 }),
            max: 50,
          },
        ]}
      >
        <Input placeholder="Type" />
      </Form.Item>

      <Form.Item
        label={$t("FlarmID")}
        name="flarm"
        rules={[{ required: false }]}
      >
        <Input placeholder="123456" />
      </Form.Item>

      <Form.Item label={$t("Zitplaatsen")} name="pilots">
        <Radio.Group buttonStyle="solid">
          <Radio.Button style={{ width: 30 }} value={1}>
            1
          </Radio.Button>
          <Radio.Button style={{ width: 30 }} value={2}>
            2
          </Radio.Button>
        </Radio.Group>
      </Form.Item>

      {setDefaultPilot && <CategoryStartMethodSelect form={form} />}

      {setDefaultPilot && vliegers && (
        <Form.Item
          label={
            <p>
              {$t("Piloot")}{" "}
              <HelpBubble
                content={$t(
                  "Indien een vlucht gestart is zal dit lid automatisch aangemeld worden als gezagvoerder"
                )}
              />
            </p>
          }
          name="default_pilot_id"
          rules={[{ required: false }]}
        >
          <Select
            showSearch
            placeholder={$t("Selecteer default pilot")}
            allowClear
            filterOption={(input, option) => {
              const label = option?.label || option?.children;
              return String(label).toLowerCase().includes(input.toLowerCase());
            }}
          >
            {vliegers.map(
              (vlieger) =>
                vlieger.id > 0 && (
                  <Select.Option key={vlieger.id} value={vlieger.id}>
                    {vlieger.name ||
                      `${vlieger.first_name} ${vlieger.last_name}`.trim()}
                  </Select.Option>
                )
            )}
          </Select>
        </Form.Item>
      )}
    </Form>
  );
};
